import {
	GET_REGIONS,
	ADD_REGION,
    GET_DISTRICTS_FOR_REGION,
	DELETE_REGION,
	UPDATE_REGION
} from '../../Actions/Admin/ManageRegionActions';

const initialState = {
	regions: [],
	districtsForRegion: []
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_REGIONS:
			return {
				...state,
				regions: action.payload
			};

		case ADD_REGION:
			return {
				...state,
				regions: action.payload
			};
		case DELETE_REGION:
			return {
				...state,
				regions: action.payload
			};
        case GET_DISTRICTS_FOR_REGION:
			return {
				...state,
				districtsForRegion: action.payload
			};
		case UPDATE_REGION:
			return {
				...state,
				regions: action.payload
			};

		default:
			return state;
	}
};
